import { trackResolved, trackTitle } from './music.js'

// A track's title, drawn so the normaliser's casing is a style and not a claim.
//
// 🔴 LIFTED OUT OF `MusicPanel.jsx` BY P6-182 RATHER THAN COPIED INTO THE FEED,
// which is `Person.jsx`'s reason arriving a second time: *"It is four lines of
// JSX. That is exactly the size of thing that gets copied."* The activity feed
// names the track that entered the canon, and a second copy of this would be a
// second decision about what to draw when the store has no name for one.
//
// `data-resolved` is what `app.css` keys the capitalisation on. The full
// argument for that being CSS rather than a JS title-caser — and its known
// imperfection, `dj shadow` rendering as `Dj Shadow` — is in `MusicPanel.jsx`'s
// header, next to the retirement condition that would end it.
//
// ⚠️ A TRACK THE STORE HAS NEVER SEEN HAS NO TITLE AT ALL. `_track_fields` sends
// `null` rather than inventing one — *"inventing a title here would put a guess
// in a field a human reads as a fact"* — so the page says that in words instead
// of printing a raw `artist::title` key at somebody.

export default function TrackTitle({ track, className }) {
  const title = trackTitle(track)
  if (title === null) {
    return (
      <span className={className} data-testid="track-unnamed">
        A track we have no name for
      </span>
    )
  }
  return (
    <span className={className} data-resolved={trackResolved(track) ? 'true' : 'false'}>
      {title}
    </span>
  )
}
